module.exports = __webpack_public_path__ + "img/ditu3.712e4aa3.png";